export default __webpack_public_path__ + "static/media/chat-18x12-grey.790ab709.svg";